import { combineReducers } from 'redux'
import { serviceReducer } from './serviceReducer'

export const appReducer = combineReducers({
  service: serviceReducer,
})
